import { createPortal } from 'react-dom';

// Draws its children at the top of the V3 page instead of where they are written. A blade or a dialog written inside a table row would otherwise be
// stacked with that row (a sticky cell or an open-in-place row makes its own layer), and the row's Delete button floated over the blade. Inside the
// .v3 root so the page's styles and colours still apply; on the body when there is none (the tests).
export default function Portal({ children }) {
  return createPortal(children, document.querySelector('.v3') || document.body);
}
